import { render, staticRenderFns } from "./FeedInventoryAllBarnsPage.vue?vue&type=template&id=0f4ade95&scoped=true&"
import script from "./FeedInventoryAllBarnsPage.vue?vue&type=script&lang=js&"
export * from "./FeedInventoryAllBarnsPage.vue?vue&type=script&lang=js&"
import style0 from "./FeedInventoryAllBarnsPage.vue?vue&type=style&index=0&id=0f4ade95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ade95",
  null
  
)

export default component.exports